import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import BoxShadow from "../../../shared/BoxShadow/BoxShadow";
import ManageAssignmentComonent from "../../../components/Orgination/ManageAssignment/ManageAssignmentComonent";

const UpdateAssignment = () => {
  return (
    <AdminPanelLayout>
      <BoxShadow>
        <ManageAssignmentComonent />
      </BoxShadow>
    </AdminPanelLayout>
  );
};

export default UpdateAssignment;
